export default {
  name: 'Demo Site',
  tel: '',
  email: ''
}
